export default function groupByLocationAndPosition(usersOrShifts, locationId, positionId) {
  const matching = [];
  const other = [];

  usersOrShifts.forEach((userOrShift) => {
    if (doesMatch(userOrShift, locationId, positionId)) {
      matching.push(userOrShift);
    } else {
      other.push(userOrShift);
    }
  });

  return { matching, other };
}

function doesMatch(userOrShift, locationId, positionId) {
  if (userOrShift.type === 'shift') {
    return userOrShift.location.id === locationId && userOrShift.position.id === positionId;
  }
  return (
    userOrShift.locationIds.includes(locationId) && userOrShift.positionIds.includes(positionId)
  );
}
